import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';

import { EntraIdGroupPicker, EntraIdServicePrincipalPicker } from './fields';

/** The frontend plugin that contributes the two Microsoft Entra picker fields. */
const entraPickersPlugin = createFrontendPlugin({
  extensions: [
    FormFieldBlueprint.make({
      name: 'entra-id-group-picker',
      params: { field: async () => EntraIdGroupPicker },
    }),
    FormFieldBlueprint.make({
      name: 'entra-id-service-principal-picker',
      params: { field: async () => EntraIdServicePrincipalPicker },
    }),
  ],
  pluginId: 'entra-pickers',
});

/** Default frontend plugin export that registers both Microsoft Entra picker fields. */
export default entraPickersPlugin;
